import { type FC, forwardRef } from 'react';
import { optionalProp } from '../core';
import { Theme } from '../types/enums';
import Notification from '../Notification/Notification/Notification';
import { useTranslation } from '../Translation/TranslationProvider';
import { detectBrowser } from './DetectBrowser';
import { type BrowserMessagePropsType } from './types/propsType';

const BrowserMessage: FC<BrowserMessagePropsType> = forwardRef<HTMLDivElement, BrowserMessagePropsType>(
  ({ onCloseClick, title, description }, ref) => {
    const t = useTranslation();

    return (
      <Notification
        message={title ?? t('nextgen.BrowserDetection.message')}
        theme={Theme.WARNING}
        description={description ?? t('nextgen.BrowserDetection.description')}
        {...optionalProp('onCloseClick', onCloseClick)}
        data-testid="browserMessage-test-id"
        forwardedRef={ref}
      />
    );
  },
);
BrowserMessage.displayName = 'BrowserMessage';
export { detectBrowser };
export default BrowserMessage;
